// Generate a stable-per-mount idempotency nonce. Re-submits of the same form
// instance (e.g. retry after a network timeout) reuse the same nonce, so
// Stripe deduplicates the charge.
export function generateIdempotencyNonce() {
  return (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`
}
